import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ExclamationOutlinedSvg from "@ant-design/icons-svg/es/asn/ExclamationOutlined";
import AntdIcon from "../components/AntdIcon";
var ExclamationOutlined = function ExclamationOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ExclamationOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ExclamationOutlined.displayName = 'ExclamationOutlined';
}
export default /*#__PURE__*/React.forwardRef(ExclamationOutlined);